import{a as e}from"./chunk-O4CMJPNZ.js";import{a as c}from"./chunk-GUSWVO3S.js";import{e as t}from"./chunk-HSTWW743.js";import{m as o}from"./chunk-HBP5N4FR.js";o();c();function f(r){e.dispatch(t(r))}export{f as a};
//# sourceMappingURL=chunk-APRFXAZK.js.map
